import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { FireBaseService } from '../../services/firebase.service';
import { Router, ActivatedRoute, Params, ParamMap} from '@angular/router';
import { User } from '../../models/user';
import { CamperVan } from '../../models/campervan';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window/directives/snazzy-info-window';
import { Observable } from 'rxjs/Observable';
import { last } from '@angular/router/src/utils/collection';
import { AuthService } from '../../core/auth.service';
import { AngularFireAuth } from 'angularfire2/auth';
import {} from '@types/googlemaps';
import { FollowService } from '../../services/follow.service';
import { size } from 'lodash';



@Component({
  selector: 'app-userdetail',
  templateUrl: './userdetail.component.html',
  styleUrls: ['./userdetail.component.css']
})
export class UserdetailComponent implements OnInit {

  id: string;
  user: any;
  imageUrl: any;
  campervan: any;

  messageBox: boolean =  false;

  mySwitch: boolean;



  userCollection: AngularFirestoreCollection<any>;
  userList: Observable<any[]>;
  userListIDs: string[];
  howManyUsers: number = 0;
  randomUserRouter: string = '';

  showMForm: boolean = false;


  loginState: boolean = false;

  loginStateTEST;

  loggedInUser;

  userObject: object;

  // Following Service
  followerCount: number;
  isFollowing: boolean;
  followers;
  following;

    currentUser = null;


    // Zoom Level
    zoom = 10;
    // setting Default Locations
    lat = 51.678418;
    lng = 7.809007;

    public followers$: Observable<any[]>;
    public following$: Observable<any[]>;

  public mapStyle = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#46bcec"
            },
            {
                "visibility": "on"
            }
        ]
    }
];




// follower test
    followDoc: AngularFirestoreDocument<any>;
    followObs: Observable<any>;

    followCollection: AngularFirestoreCollection<any>;



  constructor(@Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef,
    private firebaseService: FireBaseService,
    private router: Router,
    private route: ActivatedRoute,
    private afs: AngularFirestore, public auth: AuthService, private afAuth: AngularFireAuth,
    private followSvc: FollowService
  ) {

    this.userObject = auth.getUserObject();
    console.log(this.userObject);
    //this.loggedInUser = this.afAuth.auth.currentUser.uid;
    console.log(this.loggedInUser);

    this.userListIDs = [];

  
    this.userCollection = this.afs.collection<any>('users');
    this.userList = this.userCollection.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        const uID = a.payload.doc.id;
        console.log('my user ids', uID);
        console.log(data);
        this.userListIDs.push(data.uid);
        this.getRandomUser(this.userListIDs);
        console.log(this.userListIDs);
        return { id, ...data };
      });
    });


   
  }



  ngOnInit() {
    // get Id of Router
    this.route.paramMap.subscribe((params: ParamMap) => {
        this.id = params.get('id');
        console.log(this.id);

        this.init();
    });
  }

  init() {
    this.firebaseService.getUserDetails(this.id).valueChanges().subscribe(user => {
      this.user = user;
      console.log(this.user);
    });

   this.firebaseService.getCamperVanByUserId(this.id).valueChanges().subscribe(campervan => {
      this.campervan = campervan[0];
      this.mySwitch = this.campervan.ontheroad;
      this.lat = this.campervan.location.lat;
      this.lng = this.campervan.location.lng;
      console.log(this.campervan);

    });


    console.log('this is my id I pass over:', this.currentUser);
    this.followers$ = this.followSvc.getFollowers$(this.id);
    this.following$ = this.followSvc.getFollowing$(this.id);



    console.log('authuser id', this.auth.userId);

        // get my user Id 
    this.afAuth.authState.subscribe(userData => {
        this.currentUser = userData.uid;
        console.log('Should be my user id', this.currentUser);
        
            // FollowService: Checks if the currently logged in user is following the viewed user
            this.following = this.followSvc.getFollowing(this.currentUser, this.id).subscribe(
            following => {
                console.log('following', following);
                this.isFollowing = following;
            }
            );


            // retrieves the follower count for a users profile
            this.followers = this.followSvc.getFollowers(this.currentUser).subscribe( followers => {
                this.followerCount = this.countFollowers(followers);
            });
            
    });

   
    


  } // ngOnInit

  private countFollowers(followers) {
      console.log('cheeeck', followers);
      if (followers === null || followers === undefined) {
          return 0;
      } else {
          return size(followers);
      }
  }
  

  toggleFollow(){
      if (this.isFollowing) {
          this.followSvc.unfollow(this.currentUser, this.id);
          this.isFollowing = false;
      } else {
          this.followSvc.follow(this.currentUser, this.id);
          this.isFollowing = true;
      }
  }

  follow() {
    console.log(this.currentUser, this.id);
    this.followSvc.follow(this.currentUser, this.id);
  }

  unfollow() {
    this.followSvc.unfollow(this.currentUser, this.id);
  }


  showMessageForm() {
    console.log('show message form', this.auth);
    
    this.showMForm = !this.showMForm;
    
   
  }

  messageUser(){
    console.log('message');
  }


  getRandomUser(userListArray) {
    userListArray.slice();
    const index = userListArray.indexOf(this.id);
    console.log('my index', index);
    if (index > -1) {
      userListArray.splice(index, 1);
   }
   console.log('my new array', userListArray);
   console.log('Array Lenght', userListArray.length);
   const randomNumber =  Math.floor((Math.random() * userListArray.length));
   console.log('my random number', randomNumber);
   this.randomUserRouter = userListArray[randomNumber];
   console.log('my new routerLink', this.randomUserRouter);
  }


  openMessageBox() {
    if ( this.auth.loggedIn) { 
    this.messageBox = !this.messageBox;
    }
  }





  

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/userdetail/userdetail.component.ts